<template>
  <div class="fl sidebar">
    <el-menu
      router
        :default-active="defaultUrl"
        class="el-menu-vertical-demo"
        @open="handleOpen"
        @close="handleClose"
        background-color="rgba(0,0,0,0.20)"
        text-color="#fff"
        active-text-color="#ffd04b">
      <el-menu-item index="/">
        <i class="el-icon-menu"></i>
        <span slot="title">大数据首页</span>
      </el-menu-item>
      <el-menu-item index="/charts">
        <i class="el-icon-picture"></i>
        <span slot="title">图表对比</span>
      </el-menu-item>
      <el-submenu index="3">
        <template slot="title">
          <i class="el-icon-document"></i>
          <span slot="title">数据报表 </span>
        </template>
        <el-menu-item-group>
         
          <el-menu-item index="/channel">基础报表</el-menu-item>
          <el-menu-item index="/device">设备报表</el-menu-item>
          <el-menu-item index="/goodsRep">商品报表</el-menu-item>
          <el-menu-item index="/classRep">矩阵报表</el-menu-item>
          <el-menu-item index="/reports">自定义报表</el-menu-item>
        </el-menu-item-group>
      </el-submenu>
      <el-submenu index="4">
        <template slot="title">
          <i class="el-icon-share"></i>
          <span slot="title">设备管理 </span>
        </template>
        <el-menu-item-group>
          <el-menu-item index="/devices">设备分组</el-menu-item>
          <el-menu-item index="/devicesStart">已启用设备</el-menu-item>
          <el-menu-item index="/devicesUnStart">未启用设备</el-menu-item>
        </el-menu-item-group>
      </el-submenu>
      <el-submenu index="5">
        <template slot="title">
          <i class="el-icon-goods"></i>
          <span slot="title">商品管理</span>
        </template>
        <el-menu-item-group>
          <el-menu-item index="/goods">商品SKU管理</el-menu-item>
          <el-menu-item index="/goodsClass">商品分类管理</el-menu-item>
        </el-menu-item-group>
      </el-submenu>
      <el-menu-item index="/results">
        <i class="el-icon-news"></i>
        <span slot="title">订单详情</span>
      </el-menu-item>
    </el-menu>
  </div>
</template>

<script>
export default {
  name: 'cMenu',
  data () {
    return {
      defaultUrl: this.$route.path
    }
  },
  watch: {
    '$route':'getPath'
  },
  methods: {
    getPath () {
      this.defaultUrl = this.$route.path;
    },
    handleOpen (key, keyPath) {
      //console.log(key, keyPath)
    },
    handleClose (key, keyPath) {
      //console.log(key, keyPath)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .sidebar {
    width: 200px;
  }
  .sidebar li {
    border-bottom: 1px solid rgba(255,255,255, 0.1);
    display: block;
    margin: 0;
    padding: 0;
  }
  
  .el-menu {
  	border: none;
  }
  .is-active {
    background-color: rgba(0,0,0,0.20)
  }
  .el-menu-item-group li {
    padding-left: 70px!important;
  }
  .wraper {
    overflow:hidden;
  }
</style>



// WEBPACK FOOTER //
// src/components/cMenu.vue